module.exports = __webpack_public_path__ + "static/media/image.6e9f4c5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/EOFYtrends/image.png
// module id = 86
// module chunks = 0